import Close from "@/components/common/icons/close"
import Modal from "react-modal"
import Details from "@/common/cards/person/details"
import styles from "./modal.module.css"

export default function PersonModal({ isOpen, post, toggleModal }) {
  Modal.setAppElement("#__next")

  const customStyles = {
    overlay: {
      display: "flex",
      backgroundColor: "rgba(0, 0, 0, .5)",
      zIndex: 1000,
      alignItems: "center",
      justifyContent: "center"
    }
  }

  return (
    <Modal
      id="person-modal"
      isOpen={isOpen}
      style={customStyles}
      shouldReturnFocusAfterClose={true}
      shouldCloseOnOverlayClick={true}
      className={styles.modal}>
      <div className="close-wrapper" onClick={() => toggleModal(false)}>
        <div className="close">
          <Close className="icon" />
        </div>
      </div>
      <Details person={post} />
    </Modal>
  )
}
